var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { EditPage } from "./editing";
import { createSelector } from "react-sweet-state";
import { EventCreationState } from "./event/event";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { EntityValidator, FieldValidator } from "framework/validation/validator";
import { AgeType, CompetitionClassType, CompetitionDefaults, CompetitionType, CompetitorType, DisciplineType, EventOfficialDefaults, EventState, SeriesType } from "public_app/events/entity";
import { apiCreateCompetition, apiCreateEvent, apiCreateEventOfficial, apiDeleteCompetition, apiDeleteEventOfficial, apiGetCompetitions, apiGetEvent, apiGetEventOfficials, apiGetEvents, apiUpdateCompetition, apiUpdateEvent } from "public_app/events/endpoint";
import { load, loadAll, loadLast, update } from "framework/state/loader";
import { addMonths } from "framework/state/types";
import { createActionsHook } from "react-sweet-state";
import { setEntityField } from "framework/state/setfield";
import { getAdjudicatorLicenceKeys, getAdjudicatorLicenceNaming, getOfficialLicenseKey, getOfficialRoles, OfficialRole } from "public_app/officials/entity";
import { apiGetOfficial, apiGetOfficials } from "public_app/officials/endpoint";
import { updateByCollectionResponse } from "framework/state/collection";
import { ForeignAdjudicatorDefaults } from "public_app/foreignAdjudicators/entity";
import { apiCreateForeignAdjudicator } from "public_app/foreignAdjudicators/endpoint";
import { apiGetCompAges, apiGetCompClasses, apiGetCompCompetitors, apiGetCompDefaultDances, apiGetCompDisciplines, apiGetCompSeries, apiGetCompTypes } from "public_app/competitions/indexes/endpoint";
import { DancesSetType } from "public_app/competitions/indexes/entity";
import { CompetitionEditAction, NewCompetitionPhase } from "./competitions/competitions";
import { getIsoStringDate } from "framework/helpers";
var Tabs_StateDefaults = {
    selectedEditPage: EditPage.EventBaseData,
};
var tabs_setPage = function (editPage) { return function (store) {
    store.setState(function (draft) {
        draft.s_tabs.selectedEditPage = editPage;
    });
}; };
var Event_StateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: {
        eventCompetitions: []
    }, errors: __assign({}, NoEntityError), lastSavedEntity: {}, creationState: EventCreationState.None, checkPassed: false, showCancelDialog: false });
var event_hasChanges = function (draft) {
    return JSON.stringify(draft.s_event.entity) != JSON.stringify(draft.s_event.lastSavedEntity);
};
var event_setEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.s_event, field, value, validator, storeInvalidValue);
    });
}; };
var event_validate = function (store, requireExisting) {
    var entity = store.getState().s_event.entity;
    var validator = EntityValidator();
    if (entity.eventCompetitions[0].promoterWeb) {
        validator.storeFieldResult("eventCompetitions[0].promoterWeb", FieldValidator()
            .validateUrl(entity.eventCompetitions[0].promoterWeb)
            .getResult());
    }
    if (entity.eventCompetitions[0].promoterPropagation) {
        validator.storeFieldResult("eventCompetitions[0].promoterPropagation", FieldValidator()
            .validateUrl(entity.eventCompetitions[0].promoterPropagation)
            .getResult());
    }
    if (entity.eventCompetitions[0].bankAccount) {
        validator.storeFieldResult("eventCompetitions[0].bankAccount", FieldValidator()
            .validateNotEmpty(entity.eventCompetitions[0].bankAccount)
            .validateBankAccountNumber(entity.eventCompetitions[0].bankAccount)
            .getResult());
    }
    store.setState(function (draft) {
        draft.s_event.errors = validator.getResult();
    });
    return validator.isValid();
};
var event_showCancelDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.s_event.showCancelDialog = true;
    });
}; };
var event_hideCancelDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.s_event.showCancelDialog = false;
    });
}; };
var event_cancelCheck = function () { return function (store) {
    var state = store.getState();
    if (state.s_event.checkPassed) {
        store.setState(function (draft) {
            draft.s_event.checkPassed = false;
        });
    }
}; };
var event_loadEvent = function (eventId) { return function (store) {
    var state = store.getState();
    if (state.s_event.checkPassed) {
        store.setState(function (draft) {
            draft.s_event.checkPassed = false;
        });
    }
    var loader = function () { return apiGetEvent(eventId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            var draftState = draft.s_event;
            updateByEntityResponse(draftState, response);
            if (response.succeeded) {
                draftState.lastSavedEntity = draftState.entity;
            }
        });
    };
    load(store, loader, stateProducer, function (s) { return s.s_event; });
}; };
var event_saveEvent = function (forcedSave, eventState) {
    if (eventState === void 0) { eventState = null; }
    return function (store) {
        if (!event_validate(store, false)) {
            return;
        }
        if (!forcedSave && !event_hasChanges(store.getState())) {
            return;
        }
        var entity = store.getState().s_event.entity;
        var transportEntity = __assign(__assign({}, entity), { dateTo: entity.dateFrom, eventCompetitions: [] });
        var isExisting = entity.id != null && entity.id !== 0;
        for (var _i = 0, _a = entity.eventCompetitions; _i < _a.length; _i++) {
            var e = _a[_i];
            var ev = __assign({}, e);
            if (eventState !== null) {
                ev.state = eventState;
            }
            transportEntity.eventCompetitions.push(ev);
        }
        var loader = function () { return isExisting ? apiUpdateEvent(transportEntity) : apiCreateEvent(transportEntity); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                var draftState = draft.s_event;
                updateByEntityResponse(draftState, response);
                if (response.succeeded) {
                    draftState.lastSavedEntity = draftState.entity;
                    if (eventState === EventState.Checked) {
                        draftState.checkPassed = true;
                    }
                }
                if (draftState.creationState === EventCreationState.Creating) {
                    draftState.creationState = response.succeeded ? EventCreationState.Created : EventCreationState.Failed;
                }
            });
        };
        load(store, loader, stateProducer, function (s) { return s.s_event; });
    };
};
var event_createEvent = function () { return function (store) {
    store.setState(function (draft) {
        var draftState = draft.s_event;
        var eventDate = addMonths(new Date(), 2);
        draftState.entity = {
            dateFrom: eventDate,
            dateTo: eventDate,
            eventCompetitions: [
                {
                    id: 0,
                    state: EventState.Private,
                    date: eventDate,
                    name: "Nová soutěžní akce",
                    city: "město",
                    dayOfEvent: 1,
                }
            ]
        };
        draftState.creationState = EventCreationState.Creating;
    });
}; };
var event_resetCreationState = function () { return function (store) {
    store.setState(function (draft) {
        draft.s_event.creationState = EventCreationState.None;
    });
}; };
var OfficialsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), newOfficial: null, showNewOfficialDialog: false, newOfficialGlobErrors: [] });
var loadEventCompOfficialsFunction = function (eventId, store) {
    var loader = function () { return apiGetEventOfficials(eventId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.s_officials.officials, response);
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.s_officials.officials; });
};
var officials_loadEventCompOfficials = function (eventId) { return function (store) {
    loadEventCompOfficialsFunction(eventId, store);
}; };
var officials_deleteOfficial = function (official) {
    return function (store) {
        var updater = function () { return apiDeleteEventOfficial(official.eventId, official.id); };
        var stateProducer = function (store, _, response) {
            if (response.succeeded) {
                store.setState(function (draft) {
                    var item = draft.s_officials.officials.collection.find(function (x) { return x.id == official.id; });
                    var index = draft.s_officials.officials.collection.indexOf(item);
                    if (index > -1) {
                        draft.s_officials.officials.collection.splice(index, 1);
                    }
                });
            }
            else {
                store.setState(function (draft) {
                    var _a;
                    var item = draft.s_officials.officials.collection.find(function (x) { return x.id == official.id; });
                    if (item !== undefined) {
                        item.globalErrors = response.data['errors'] ? (_a = response.data['errors']['eventCompetitions[0].officials']) === null || _a === void 0 ? void 0 : _a.errors : null;
                    }
                });
            }
        };
        update(store, updater, stateProducer);
    };
};
var officials_addNewOfficial = function (official) { return function (store) {
    store.setState(function (draft) {
        draft.s_officials.officials.collection.push(official);
        draft.s_officials.officials.newOfficial = {
            id: 0,
            eventId: draft.s_officials.eventId,
            dayOfEvent: 1,
        };
    });
}; };
var officials_setRoleOfOfficial = function (id, role) { return function (store) {
    store.setState(function (draft) {
        var official = draft.s_officials.officials.collection.find(function (o) { return o.id == id; });
        if (official !== undefined) {
            official.role = role;
        }
    });
}; };
var AllOfficialsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var officials_loadAllOfficials = function () { return function (store) {
    var loader = function () { return apiGetOfficials(); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.s_officials.allOfficials, response);
        });
    };
    load(store, loader, stateProducer, function (s) { return s.s_officials.allOfficials; });
}; };
var officials_filterOfficials = function (filter) { return function (store) {
    store.setState(function (draft) {
        if (filter) {
            draft.s_officials.newOfficial.filteredOfficials = draft.s_officials.allOfficials.collection.slice(0)
                .filter(function (x) { return x.surname.toLocaleLowerCase().includes(filter.trim().toLocaleLowerCase()); });
            if (!draft.s_officials.newOfficial.filteredOfficials.length) {
                draft.s_officials.newOfficial.filteredOfficials.push({
                    id: -1,
                    surname: "* registrovat nového zahraničního porotce",
                    name: "",
                    club: "",
                    country: "",
                    licences: []
                });
            }
        }
        else {
            draft.s_officials.newOfficial.filteredOfficials = [];
        }
    });
}; };
var officials_getAvailableOfficialRoles = function (idt) {
    if (idt === void 0) { idt = null; }
    return function (store) {
        var _a, _b;
        if (idt) {
            var licences = (_b = (_a = store.getState().s_officials.allOfficials.collection.filter(function (x) { return x.id == idt; })[0]) === null || _a === void 0 ? void 0 : _a.licences) !== null && _b !== void 0 ? _b : [];
            return getOfficialRoles().filter(function (x) { return licences.find(function (r) { return r.role == x.key; }) != null; });
        }
        return getOfficialRoles();
    };
};
var getOfficialByIdt = function (idt, state) {
    return state.s_officials.allOfficials.collection.find(function (x) { return x.id == idt; });
};
var NewOfficialStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: __assign({}, EventOfficialDefaults), errors: __assign({}, NoEntityError), showDialog: false, filteredOfficials: [], selectedOfficial: null, submitting: false, availableOfficialRoles: [] });
var officials_setNewOfficialRole = function (value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.s_officials.newOfficial, 'role', value, validator, storeInvalidValue);
    });
}; };
var selectOfficialFunction = function (official, store) {
    store.setState(function (draft) {
        var _a, _b;
        draft.s_officials.newOfficial.selectedOfficial = official;
        draft.s_officials.newOfficial.entity.idt = official === null || official === void 0 ? void 0 : official.id;
        draft.s_officials.newOfficial.errors = JSON.parse(JSON.stringify(NoEntityError));
        var licences = (_b = (_a = draft.s_officials.newOfficial.selectedOfficial) === null || _a === void 0 ? void 0 : _a.licences) !== null && _b !== void 0 ? _b : [];
        draft.s_officials.newOfficial.availableOfficialRoles = getOfficialRoles().filter(function (x) { return licences.find(function (r) { return r.role == x.key; }) != null; });
        if (draft.s_officials.newOfficial.availableOfficialRoles.length) {
            if (draft.s_officials.newOfficial.availableOfficialRoles.length == 1) {
                draft.s_officials.newOfficial.entity.role = draft.s_officials.newOfficial.availableOfficialRoles[0].key;
            }
            else {
                var idx = draft.s_officials.newOfficial.availableOfficialRoles.map(function (x) { return x.key; }).indexOf(draft.s_officials.newOfficial.entity.role);
                if (idx < 0) {
                    draft.s_officials.newOfficial.entity.role = OfficialRole.Unknown;
                }
            }
        }
    });
};
var officials_selectOfficial = function (official) { return function (store) {
    selectOfficialFunction(official, store);
}; };
var validateSelectedOfficial = function (store) {
    var entity = store.getState().s_officials.newOfficial.entity;
    var validator = EntityValidator();
    validator.storeFieldResult("idt", FieldValidator()
        .validateNotEmpty(entity.idt)
        .getResult());
    validator.storeFieldResult("role", FieldValidator()
        .validateNotEmpty(entity.role)
        .validateIntGZ(entity.role)
        .getResult());
    store.setState(function (draft) {
        draft.s_officials.newOfficial.errors = validator.getResult();
    });
    return validator.isValid();
};
var addSelectedOfficialFunction = function (store) {
    if (!validateSelectedOfficial(store)) {
        return;
    }
    store.setState(function (draft) {
        draft.s_officials.newOfficial.submitting = true;
        draft.s_officials.newOfficial.entity.eventId = draft.s_officials.eventId;
    });
    var entity = store.getState().s_officials.newOfficial.entity;
    var updater = function () { return apiCreateEventOfficial(entity.eventId, entity); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.s_officials.newOfficial, response);
            if (response.succeeded) {
                draft.s_officials.newOfficial.submitting = false;
                draft.s_officials.officials.collection.push(draft.s_officials.newOfficial.entity);
                draft.s_officials.newOfficial.entity = JSON.parse(JSON.stringify(EventOfficialDefaults));
                draft.s_officials.newOfficial.entity.role = OfficialRole.Unknown;
                draft.s_officials.newOfficial.availableOfficialRoles = [];
                draft.s_officials.newOfficial.selectedOfficial = null;
            }
            else {
                draft.s_officials.newOfficial.submitting = false;
            }
        });
    };
    update(store, updater, stateProducer, function (s) { return s.s_officials.newOfficial; });
};
var officials_addSelectedOfficial = function () { return function (store) {
    addSelectedOfficialFunction(store);
}; };
var openNewOfficialDialogFunction = function (store) {
    store.setState(function (draft) {
        draft.s_officials.newOfficial.selectedOfficial = null;
        draft.s_officials.newOfficial.showDialog = true;
        draft.s_officials.newOfficial.entity = JSON.parse(JSON.stringify(EventOfficialDefaults));
        draft.s_officials.newOfficial.errors = JSON.parse(JSON.stringify(NoEntityError));
        draft.s_officials.registerForeignAdjudicator.showDialog = false;
    });
};
var officials_openNewOfficialDialog = function () { return function (store) {
    openNewOfficialDialogFunction(store);
}; };
var RegisterForeignAdjudicatorStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: __assign({}, ForeignAdjudicatorDefaults), errors: __assign({}, NoEntityError), showDialog: false, submitting: false });
var officials_setRegisterForeignAdjudicatorEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.s_officials.registerForeignAdjudicator, field, value, validator, storeInvalidValue);
    });
}; };
var officials_openRegisterForeignAdjudicatorDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.s_officials.registerForeignAdjudicator.showDialog = true;
        draft.s_officials.registerForeignAdjudicator.entity = JSON.parse(JSON.stringify(ForeignAdjudicatorDefaults));
        draft.s_officials.registerForeignAdjudicator.errors = JSON.parse(JSON.stringify(NoEntityError));
        draft.s_officials.newOfficial.showDialog = false;
    });
}; };
var validateNewForeignAdjudicatorForRegistration = function (store) {
    var entity = store.getState().s_officials.registerForeignAdjudicator.entity;
    var validator = EntityValidator();
    validator.storeFieldResult("name", FieldValidator()
        .validateNotEmpty(entity.name)
        .getResult());
    validator.storeFieldResult("surname", FieldValidator()
        .validateNotEmpty(entity.surname)
        .getResult());
    validator.storeFieldResult("country", FieldValidator()
        .validateNotEmpty(entity.country)
        .getResult());
    store.setState(function (draft) {
        draft.s_officials.registerForeignAdjudicator.errors = validator.getResult();
    });
    return validator.isValid();
};
var officials_registerAndAddNewForeignAdjudicator = function () { return function (store) {
    var registered_adjudicator_idt = null;
    if (!validateNewForeignAdjudicatorForRegistration(store)) {
        return;
    }
    store.setState(function (draft) {
        draft.s_officials.registerForeignAdjudicator.submitting = true;
    });
    var entity = store.getState().s_officials.registerForeignAdjudicator.entity;
    var updater = function () { return apiCreateForeignAdjudicator(entity); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.s_officials.registerForeignAdjudicator, response);
            if (response.succeeded) {
                registered_adjudicator_idt = Number(draft.s_officials.registerForeignAdjudicator.entity.id);
                draft.s_officials.registerForeignAdjudicator.submitting = false;
                draft.s_officials.registerForeignAdjudicator.entity = JSON.parse(JSON.stringify(ForeignAdjudicatorDefaults));
                officials_closeDialogFunction(draft);
            }
            else {
                draft.s_officials.registerForeignAdjudicator.submitting = false;
            }
        });
        if (registered_adjudicator_idt !== null) {
            // go back to the new foreign adjudicator dialog
            openNewOfficialDialogFunction(store);
            loadAndAddOfficialAsAdjudicator(registered_adjudicator_idt, store);
        }
    };
    update(store, updater, stateProducer, function (s) { return s.s_officials.registerForeignAdjudicator; });
}; };
var OfficialStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var loadAndAddOfficialAsAdjudicator = function (idt, store) {
    var loader = function () { return apiGetOfficial(idt); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.s_officials.official, response);
        });
        if (response.succeeded) {
            var state = store.getState();
            if (state.s_officials.officials.collection.map(function (o) { var _a; return (_a = o.idt) !== null && _a !== void 0 ? _a : null; }).indexOf(state.s_officials.official.entity.id) < 0) {
                store.setState(function (draft) {
                    draft.s_officials.allOfficials.collection.push(draft.s_officials.official.entity);
                });
            }
            // select the registered adjudicator
            selectOfficialFunction(store.getState().s_officials.official.entity, store);
            store.setState(function (draft) {
                draft.s_officials.newOfficial.entity.role = OfficialRole.Adjudicator;
            });
            // add adjudicator to this event
            addSelectedOfficialFunction(store);
        }
    };
    load(store, loader, stateProducer, function (s) { return s.s_officials.official; });
};
// All
var officials_closeDialogFunction = function (draft) {
    draft.s_officials.newOfficial.showDialog = false;
    draft.s_officials.newOfficial.selectedOfficial = null;
    draft.s_officials.registerForeignAdjudicator.showDialog = false;
};
var officials_closeDialog = function () { return function (store) {
    store.setState(function (draft) {
        officials_closeDialogFunction(draft);
    });
}; };
var officials_setEventId = function (eventId) { return function (store) {
    store.setState(function (draft) {
        draft.s_officials.eventId = eventId;
        draft.s_officials.officials.collection = [];
    });
    loadEventCompOfficialsFunction(eventId, store);
}; };
var Officials_StateDefaults = __assign(__assign({}, LoadingStateDefaults), { eventId: null, official: OfficialStateDefaults, officials: OfficialsStateDefaults, allOfficials: AllOfficialsStateDefaults, newOfficial: NewOfficialStateDefaults, registerForeignAdjudicator: RegisterForeignAdjudicatorStateDefaults });
var CompetitionDefaults_str = __assign(__assign({}, CompetitionDefaults), { seriesId: 0, typeId: 0, ageId: 0, fromClassId: 0, disciplineId: 0, competitorId: 0, startFee: "" });
var FilterStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: CompetitionDefaults_str, errors: __assign({}, NoEntityError), filtered_competition_ids: [] });
var competitions_resetFilterFunction = function (draft) {
    draft.s_competitions.filter.entity = CompetitionDefaults_str;
};
var competitions_resetFilter = function () { return function (store) {
    store.setState(function (draft) {
        competitions_resetFilterFunction(draft);
        competitions_filterCompetitionsFunction(draft);
    });
}; };
var competitions_setFilterEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.s_competitions.filter, field, value, validator, storeInvalidValue);
        competitions_filterCompetitionsFunction(draft);
    });
}; };
var competitions_filterCompetitionsFunction = function (draft) {
    var f = draft.s_competitions.filter.entity;
    draft.s_competitions.filter.filtered_competition_ids = draft.s_competitions.competitions.collection
        .filter(function (e) { return e.entity.seriesId == f.seriesId || !f.seriesId; })
        .filter(function (e) { return e.entity.typeId == f.typeId || !f.typeId; })
        .filter(function (e) { return e.entity.ageId == f.ageId || !f.ageId; })
        .filter(function (e) { return e.entity.competitorId == f.competitorId || !f.competitorId; })
        .filter(function (e) { return e.entity.disciplineId == f.disciplineId || !f.disciplineId; })
        .filter(function (e) { return e.entity.fromClassId == f.fromClassId || !f.fromClassId; })
        .filter(function (e) { var _a; return ((_a = e.entity.startFee) === null || _a === void 0 ? void 0 : _a.toString()) == f.startFee.toString() || f.startFee.toString() == ""; })
        .map(function (c) { return c.entity.id; });
};
var DefaultDancesStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: {
        set: DancesSetType.Fixed,
    }, errors: __assign({}, NoEntityError) });
var CompetitionStateDefaults = __assign(__assign({}, LoadingStateDefaults), { initialized: true, entity: __assign({}, CompetitionDefaults), errors: __assign({}, NoEntityError), lastSavedEntity: __assign({}, CompetitionDefaults), lastAction: null, showFromClassField: false, showToClassField: false, compSeriesItems: [], compTypeItems: [], compCompetitorItems: [], compAgeItems: [], compClassItems: [], compDisciplineItems: [], showDancesDialog: false, showDeleteConfirmationDialog: false, deletionFailed: false, default_dances_state: DefaultDancesStateDefaults });
var competitions_setLastActionValidationToAllCompetitions = function () { return function (store) {
    store.setState(function (draft) {
        draft.s_competitions.competitions.collection.forEach(function (cs) { return cs.lastAction = CompetitionEditAction.Validation; });
    });
}; };
var NewCompetitionStateDefaults = __assign(__assign({}, CompetitionStateDefaults), { newCompetitionPhase: NewCompetitionPhase.None, showNewCompetitionDialog: false });
var getCompetitionSubStore = function (state, compId) {
    if (compId === null) {
        return state.s_competitions.new_competition;
    }
    var comp_state = state.s_competitions.competitions.collection.find(function (c) { return c.entity.id == compId; });
    return comp_state !== null && comp_state !== void 0 ? comp_state : null;
};
var competitions_setCompetitionEntityField = function (compId, field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(getCompetitionSubStore(draft, compId), field, value, validator, storeInvalidValue);
        if (field != 'checkinEnd' && field != 'startFee') {
            competitions_updateCompetitionSelectorItemsFunction(compId, draft);
        }
    });
    if (field != 'checkinEnd' && field != 'startFee') {
        competitions_loadCompDefaultDancesFunction(compId, store);
    }
}; };
var competitions_setCompetitionEntityFieldWithSave = function (compId, field, value, validator, storeInvalidValue) { return function (store) {
    var entityJson = JSON.stringify(getCompetitionSubStore(store.getState(), compId).entity);
    store.setState(function (draft) {
        setEntityField(getCompetitionSubStore(draft, compId), field, value, validator, storeInvalidValue);
        if (field != 'checkinEnd' && field != 'startFee') {
            competitions_updateCompetitionSelectorItemsFunction(compId, draft);
        }
    });
    var load_default_dances = field != 'checkinEnd' && field != 'startFee';
    var forcedSaveBecauseEntityModified = entityJson !== JSON.stringify(getCompetitionSubStore(store.getState(), compId).entity);
    competitions_saveCompetitionFunction(compId, forcedSaveBecauseEntityModified, store, load_default_dances); // Optionally contains loadCompDefaultDancesFunction(compId, store);
}; };
var competitions_loadCompDefaultDancesFunction = function (compId, store) {
    var _a;
    var comp_state = getCompetitionSubStore(store.getState(), compId);
    var entity = comp_state.entity;
    var compDances = {
        series: entity.seriesId,
        type: entity.typeId,
        competitor: entity.competitorId,
        age: entity.ageId,
        class: (_a = entity.toClassId) !== null && _a !== void 0 ? _a : entity.fromClassId,
        discipline: entity.disciplineId,
    };
    var loader = function () { return apiGetCompDefaultDances(compDances); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(getCompetitionSubStore(draft, compId).default_dances_state, response);
        });
    };
    loadAll(store, loader, stateProducer, function (s) { return getCompetitionSubStore(s, compId).default_dances_state; });
};
var competitions_validate = function (store, compId, requireExisting) {
    var entity = getCompetitionSubStore(store.getState(), compId).entity;
    var validator = EntityValidator();
    validator.storeFieldResult("seriesId", FieldValidator()
        .validateNotEmpty(entity.seriesId)
        .validateIntGZ(entity.seriesId)
        .getResult());
    store.setState(function (draft) {
        getCompetitionSubStore(draft, compId).errors = validator.getResult();
    });
    return validator.isValid();
};
var competitions_hasChanges = function (substate) {
    return JSON.stringify(substate.entity) != JSON.stringify(substate.lastSavedEntity);
};
var competitions_addNewCompetition = function (competition, draft) {
    var new_comp_store = __assign({}, CompetitionStateDefaults);
    new_comp_store.entity = competition;
    new_comp_store.lastSavedEntity = competition;
    draft.s_competitions.competitions.collection.push(new_comp_store);
    draft.s_competitions.new_competition.showNewCompetitionDialog = false;
    competitions_updateCompetitionSelectorItemsFunction(competition.id, draft);
    competitions_filterCompetitionsFunction(draft);
};
var competitions_saveCompetitionFunction = function (compId, forcedSave, store, load_default_dances, entityModified) {
    if (load_default_dances === void 0) { load_default_dances = false; }
    if (entityModified === void 0) { entityModified = false; }
    var added_new_id = null;
    if (competitions_validate(store, compId, false)) {
        if (forcedSave || competitions_hasChanges(getCompetitionSubStore(store.getState(), compId))) {
            store.setState(function (draft) {
                draft.s_competitions.new_competition.newCompetitionPhase = NewCompetitionPhase.Submiting;
            });
            var entity_1 = JSON.parse(JSON.stringify(getCompetitionSubStore(store.getState(), compId).entity));
            var isExisting_1 = entity_1.id != null && entity_1.id !== 0;
            var updater = function () { return isExisting_1 ? apiUpdateCompetition(entity_1.eventId, entity_1) : apiCreateCompetition(entity_1.eventId, entity_1); };
            var stateProducer = function (store, _, response) {
                store.setState(function (draft) {
                    updateByEntityResponse(getCompetitionSubStore(draft, compId), response);
                    if (response.succeeded) {
                        getCompetitionSubStore(draft, compId).lastSavedEntity = getCompetitionSubStore(draft, compId).entity;
                        draft.s_competitions.new_competition.newCompetitionPhase = NewCompetitionPhase.Submitted;
                        if (!isExisting_1) {
                            competitions_addNewCompetition(getCompetitionSubStore(draft, compId).entity, draft);
                            added_new_id = getCompetitionSubStore(draft, compId).entity.id;
                        }
                    }
                    else {
                        draft.s_competitions.new_competition.newCompetitionPhase = NewCompetitionPhase.None;
                    }
                    getCompetitionSubStore(draft, compId).lastAction = CompetitionEditAction.Saving;
                });
                if (load_default_dances) {
                    competitions_loadCompDefaultDancesFunction(compId, store);
                }
                if (added_new_id !== null) {
                    competitions_loadCompDefaultDancesFunction(added_new_id, store);
                }
            };
            update(store, updater, stateProducer, function (s) { return getCompetitionSubStore(s, compId); });
        }
    }
};
var competitions_saveCompetition = function (compId, forcedSave) { return function (store) {
    competitions_saveCompetitionFunction(compId, forcedSave, store);
}; };
var competitions_updateCompSeriesItems = function (compId, draft) {
    getCompetitionSubStore(draft, compId).compSeriesItems = draft.s_competitions.items_series.collection;
};
var competitions_updateCompCompetitorItems = function (compId, draft) {
    var filter = null;
    var cs = getCompetitionSubStore(draft, compId);
    var ent = cs.entity;
    if (ent.seriesId == SeriesType.DanceSport) {
        filter = [
            CompetitorType.Couple,
            CompetitorType.Team,
            CompetitorType.Formation
        ];
    }
    if (ent.seriesId == SeriesType.Professional) {
        filter = [
            CompetitorType.Couple
        ];
    }
    if (ent.seriesId == SeriesType.DanceForAll) {
        filter = [
            CompetitorType.Couple,
            CompetitorType.SoloDancer,
            CompetitorType.Duo,
            CompetitorType.Group,
            CompetitorType.SmallTeam,
            CompetitorType.BigTeam,
        ];
        // if (ent.typeId == CompetitionType.Ranking) {
        //     filter = [CompetitorType.SoloDancer, CompetitorType.Duo];
        // } else if (ent.typeId == CompetitionType.Championship) {
        //     filter = [CompetitorType.SoloDancer, CompetitorType.Duo, CompetitorType.Group, CompetitorType.SmallTeam, CompetitorType.BigTeam];
        // } else if (ent.typeId == CompetitionType.League) {
        //     filter = [CompetitorType.SoloDancer, CompetitorType.Duo];
        // } else if (ent.disciplineId == DisciplineType.SingleDance) {
        //     filter = [CompetitorType.SoloDancer, CompetitorType.Couple];
        // } else if (ent.disciplineId == DisciplineType.FreeStyle) {
        //     filter = [CompetitorType.Duo, CompetitorType.Group, CompetitorType.SmallTeam, CompetitorType.BigTeam];
        // } else {
        //     filter = [
        //         CompetitorType.Couple,
        //         CompetitorType.SoloDancer,
        //         CompetitorType.Duo,
        //         CompetitorType.Group,
        //         CompetitorType.SmallTeam,
        //         CompetitorType.BigTeam,
        //     ];
        // }
    }
    if (ent.seriesId == SeriesType.Caribbean) {
        filter = [
            CompetitorType.SoloDancer,
            CompetitorType.Duo,
            CompetitorType.Couple,
            CompetitorType.Group,
            CompetitorType.SmallTeam,
            CompetitorType.BigTeam,
        ];
    }
    // update the items
    if (filter !== null) {
        cs.compCompetitorItems = draft.s_competitions.items_competitor.collection.filter(function (x) { return filter.indexOf(x.id) >= 0; });
    }
    else {
        cs.compCompetitorItems = draft.s_competitions.items_competitor.collection;
    }
};
var competitions_updateCompTypeItems = function (compId, draft) {
    var filter;
    var cs = getCompetitionSubStore(draft, compId);
    var ent = cs.entity;
    switch (cs.entity.seriesId) {
        case SeriesType.DanceSport:
            if (ent.competitorId === CompetitorType.Formation) {
                filter = [
                    CompetitionType.Championship,
                ];
            }
            else if (ent.competitorId === CompetitorType.Team) {
                filter = [
                    CompetitionType.Championship,
                    CompetitionType.Cup,
                ];
            }
            else {
                filter = [
                    CompetitionType.Ranking,
                    CompetitionType.Cup,
                    CompetitionType.League,
                    CompetitionType.SuperLeague,
                    CompetitionType.Championship,
                ];
            }
            break;
        case SeriesType.Professional:
            filter = [
                CompetitionType.Cup,
                CompetitionType.Championship,
            ];
            break;
        case SeriesType.DanceForAll:
            if (ent.competitorId === CompetitorType.Group || ent.competitorId === CompetitorType.SmallTeam || ent.competitorId === CompetitorType.BigTeam) {
                filter = [
                    CompetitionType.Cup,
                    CompetitionType.TopLevel,
                    CompetitionType.Championship,
                    CompetitionType.G_Cup,
                ];
            }
            else if (ent.competitorId === CompetitorType.SoloDancer || ent.competitorId === CompetitorType.Duo) {
                filter = [
                    CompetitionType.Cup,
                    CompetitionType.Ranking,
                    CompetitionType.TopLevel,
                    CompetitionType.Championship,
                    CompetitionType.League,
                    CompetitionType.SuperLeague,
                ];
            }
            else if (ent.competitorId === CompetitorType.Couple) {
                filter = [
                    CompetitionType.Cup,
                ];
            }
            else {
                filter = [
                    CompetitionType.Cup,
                    CompetitionType.Ranking,
                    CompetitionType.TopLevel,
                    CompetitionType.Championship,
                    CompetitionType.G_Cup,
                    CompetitionType.League,
                    CompetitionType.SuperLeague,
                ];
            }
            break;
        case SeriesType.Caribbean:
            filter = [
                CompetitionType.Cup,
                CompetitionType.Championship,
            ];
            break;
        default:
            cs.compTypeItems = draft.s_competitions.items_type.collection;
            // no update of value is needed
            return;
    }
    // update the items
    cs.compTypeItems = draft.s_competitions.items_type.collection.filter(function (x) { return filter.indexOf(x.id) >= 0; });
};
var competitions_updateCompAgeItems = function (compId, draft) {
    var filter = null;
    var cs = getCompetitionSubStore(draft, compId);
    var ent = cs.entity;
    if (ent.seriesId == SeriesType.DanceSport) {
        if (ent.competitorId === CompetitorType.Team && ent.typeId == CompetitionType.Championship) {
            filter = [
                AgeType.Junior,
                AgeType.Under_21,
                AgeType.Adult,
                AgeType.Senior,
            ];
        }
        else if (ent.typeId == CompetitionType.Championship) {
            filter = [
                AgeType.Juvenile,
                AgeType.Juvenile_II,
                AgeType.Junior,
                AgeType.Junior_I,
                AgeType.Junior_II,
                AgeType.Youth,
                AgeType.Under_21,
                AgeType.Adult,
                AgeType.Senior_I,
                AgeType.Senior_II,
                AgeType.Senior_III,
                AgeType.Senior_IV,
            ];
        }
        else if (ent.typeId == CompetitionType.Ranking) {
            filter = [
                AgeType.Juvenile_I,
                AgeType.Juvenile_II,
                AgeType.Junior_I,
                AgeType.Junior_II,
                AgeType.Youth,
                AgeType.Adult,
                AgeType.Senior_I,
                AgeType.Senior_II,
                AgeType.Senior_III,
                AgeType.Senior_IV,
            ];
        }
        else if (ent.typeId == CompetitionType.League || ent.typeId == CompetitionType.SuperLeague) {
            filter = [
                AgeType.Junior_I,
                AgeType.Junior_II,
                AgeType.Youth,
                AgeType.Adult,
                AgeType.Senior_I,
                AgeType.Senior_II,
                AgeType.Senior_III,
                AgeType.Senior_IV,
            ];
        }
    }
    if (ent.seriesId == SeriesType.Professional) {
        filter = [
            AgeType.Adult,
            AgeType.Senior_I,
            AgeType.Senior_II,
            AgeType.Senior_III,
            AgeType.Senior_IV
        ];
    }
    if (ent.seriesId == SeriesType.DanceForAll) {
        if (ent.competitorId === CompetitorType.Couple
            || ent.competitorId === CompetitorType.SoloDancer
            || ent.competitorId === CompetitorType.Duo
            || !ent.competitorId) {
            filter = null;
        }
        else {
            filter = [
                AgeType.Under_8,
                AgeType.Juvenile_I,
                AgeType.Juvenile_II,
                AgeType.Juvenile,
                AgeType.Junior_I,
                AgeType.Junior_II,
                AgeType.Junior,
                AgeType.Youth,
                AgeType.Under_21,
                AgeType.Adult,
            ];
        }
    }
    // update the items
    if (filter !== null) {
        cs.compAgeItems = draft.s_competitions.items_age.collection.filter(function (x) { return filter.indexOf(x.id) >= 0; });
    }
    else {
        cs.compAgeItems = draft.s_competitions.items_age.collection;
    }
};
var competitions_updateCompClassItems = function (compId, draft) {
    var filter = null;
    var cs = getCompetitionSubStore(draft, compId);
    var ent = cs.entity;
    if (ent.seriesId == SeriesType.DanceSport) {
        if (ent.typeId == CompetitionType.Championship) {
            filter = [CompetitionClassType.Open];
        }
        else if (ent.typeId == CompetitionType.League || ent.typeId == CompetitionType.SuperLeague) {
            filter = [CompetitionClassType.Open];
        }
        else if (ent.typeId == CompetitionType.Ranking) {
            if (ent.ageId == AgeType.Juvenile_I) {
                filter = [CompetitionClassType.E, CompetitionClassType.D, CompetitionClassType.C];
            }
            if (ent.ageId == AgeType.Juvenile_II) {
                filter = [CompetitionClassType.E, CompetitionClassType.D, CompetitionClassType.C];
            }
            if (ent.ageId == AgeType.Junior_I) {
                filter = [CompetitionClassType.E, CompetitionClassType.D, CompetitionClassType.C];
            }
            if (ent.ageId == AgeType.Junior_II) {
                filter = [CompetitionClassType.E, CompetitionClassType.D, CompetitionClassType.C, CompetitionClassType.B];
            }
            if ([AgeType.Youth, AgeType.Adult, AgeType.Senior_I, AgeType.Senior_II, AgeType.Senior_III, AgeType.Senior_IV].includes(ent.ageId)) {
                filter = [CompetitionClassType.E, CompetitionClassType.D, CompetitionClassType.C, CompetitionClassType.B, CompetitionClassType.A];
            }
        }
        else {
            filter = [
                CompetitionClassType.E,
                CompetitionClassType.D,
                CompetitionClassType.C,
                CompetitionClassType.B,
                CompetitionClassType.A,
                CompetitionClassType.M,
            ];
        }
    }
    if (ent.seriesId == SeriesType.Professional) {
        filter = [CompetitionClassType.Open];
    }
    if (ent.seriesId == SeriesType.DanceForAll) {
        if (ent.typeId === CompetitionType.TopLevel || ent.typeId === CompetitionType.Championship || ent.typeId === CompetitionType.G_Cup || ent.typeId === CompetitionType.League || ent.typeId === CompetitionType.SuperLeague) {
            filter = [CompetitionClassType.Open];
        }
        // else if (ent.typeId == CompetitionType.Cup) {
        //     // condition for having ranking form of competitions OR SingleDance Cup
        //     if ([CompetitorType.SoloDancer, CompetitorType.Duo].includes(ent.competitorId) && [DisciplineType.Standard, DisciplineType.Latin, DisciplineType.Standard_Latin, DisciplineType.SingleDance].includes(ent.disciplineId)) {
        //         filter = [
        //             CompetitionClassType.Open,
        //             CompetitionClassType.Novice,
        //             CompetitionClassType.Bronze,
        //             CompetitionClassType.Silver,
        //             CompetitionClassType.Gold
        //         ]
        //     } else {
        //         // ranking form doesn't exist
        //         filter = [CompetitionClassType.Open]
        //     }
        // }
        else {
            filter = [
                CompetitionClassType.Novice,
                CompetitionClassType.Bronze,
                CompetitionClassType.Silver,
                CompetitionClassType.Gold,
                CompetitionClassType.Open
            ];
        }
    }
    if (ent.seriesId == SeriesType.Caribbean) {
        filter = [CompetitionClassType.Open];
    }
    // update the items
    if (filter !== null) {
        cs.compClassItems = draft.s_competitions.items_class.collection.filter(function (x) { return filter.indexOf(x.id) >= 0; });
    }
    else {
        cs.compClassItems = draft.s_competitions.items_class.collection;
    }
};
var competitions_updateCompDisciplineItems = function (compId, draft) {
    var filter = null;
    var cs = getCompetitionSubStore(draft, compId);
    var ent = cs.entity;
    if (ent.seriesId == SeriesType.DanceSport) {
        if (ent.competitorId === CompetitorType.Formation) {
            filter = [
                DisciplineType.Standard,
                DisciplineType.Latin,
            ];
        }
        else if (ent.competitorId === CompetitorType.Team) {
            if (ent.typeId === CompetitionType.Championship) {
                filter = [
                    DisciplineType.Standard,
                    DisciplineType.Latin,
                ];
            }
            else {
                filter = [
                    DisciplineType.Standard,
                    DisciplineType.Latin,
                    DisciplineType.Standard_Latin,
                ];
            }
        }
        else if (ent.competitorId === CompetitorType.Couple) {
            if (ent.typeId === CompetitionType.Championship) {
                filter = [
                    DisciplineType.Standard,
                    DisciplineType.Latin,
                    DisciplineType.TenDance,
                    DisciplineType.ShowdanceStandard,
                    DisciplineType.ShowdanceLatin
                ];
            }
            else if (ent.typeId === CompetitionType.Cup) {
                filter = [DisciplineType.Standard, DisciplineType.Latin, DisciplineType.Standard_Latin];
            }
            else if (ent.typeId === CompetitionType.Ranking) {
                if (ent.fromClassId === CompetitionClassType.E && [AgeType.Under_8, AgeType.Juvenile, AgeType.Juvenile_I, AgeType.Juvenile_II].includes(ent.ageId)) {
                    filter = [DisciplineType.Standard_Latin];
                }
                else if (ent.ageId == null || ent.fromClassId == null) {
                    filter = [DisciplineType.Standard, DisciplineType.Latin, DisciplineType.Standard_Latin];
                }
                else {
                    filter = [DisciplineType.Standard, DisciplineType.Latin];
                }
            }
            else if (ent.typeId === CompetitionType.League || ent.typeId === CompetitionType.SuperLeague) {
                filter = [DisciplineType.Standard, DisciplineType.Latin];
            }
            else {
                filter = [
                    DisciplineType.Standard,
                    DisciplineType.Latin,
                    DisciplineType.TenDance,
                    DisciplineType.Standard_Latin,
                    DisciplineType.ShowdanceStandard,
                    DisciplineType.ShowdanceLatin
                ];
            }
        }
        else {
            filter = [
                DisciplineType.Standard,
                DisciplineType.Latin,
                DisciplineType.TenDance,
                DisciplineType.Standard_Latin,
                DisciplineType.ShowdanceStandard,
                DisciplineType.ShowdanceLatin
            ];
        }
    }
    if (ent.seriesId === SeriesType.Professional) {
        if (ent.typeId === CompetitionType.Championship) {
            if (ent.ageId === AgeType.Adult || ent.ageId == null) {
                filter = [
                    DisciplineType.Standard,
                    DisciplineType.Latin,
                    DisciplineType.TenDance,
                    DisciplineType.ShowdanceStandard,
                    DisciplineType.ShowdanceLatin,
                ];
            }
            else {
                filter = [
                    DisciplineType.Standard,
                    DisciplineType.Latin,
                    DisciplineType.TenDance,
                ];
            }
        }
        else if (ent.typeId === CompetitionType.Cup) {
            filter = [
                DisciplineType.Standard,
                DisciplineType.Latin,
                DisciplineType.Standard_Latin,
            ];
        }
        else {
            filter = [
                DisciplineType.Standard,
                DisciplineType.Latin,
                DisciplineType.TenDance,
                DisciplineType.Standard_Latin,
                DisciplineType.ShowdanceStandard,
                DisciplineType.ShowdanceLatin,
            ];
        }
    }
    if (ent.seriesId === SeriesType.DanceForAll) {
        if (ent.typeId === CompetitionType.Ranking || ent.typeId === CompetitionType.Championship) {
            filter = [
                DisciplineType.Standard,
                DisciplineType.Latin,
                DisciplineType.Standard_Latin,
            ];
        }
        else {
            filter = [
                DisciplineType.Standard,
                DisciplineType.Latin,
                DisciplineType.Standard_Latin,
                DisciplineType.SingleDance,
                DisciplineType.FreeStyle,
                DisciplineType.Other,
            ];
        }
    }
    if (ent.seriesId === SeriesType.Caribbean) {
        filter = [
            DisciplineType.Bachata,
            DisciplineType.Merengue,
            DisciplineType.Salsa,
            DisciplineType.ShowdanceBachata,
            DisciplineType.ShowdanceMerengue,
            DisciplineType.ShowdanceSalsa,
            DisciplineType.Caribbean,
        ];
    }
    // update the items
    if (filter !== null) {
        cs.compDisciplineItems = draft.s_competitions.items_discipline.collection.filter(function (x) { return filter.indexOf(x.id) >= 0; });
    }
    else {
        cs.compDisciplineItems = draft.s_competitions.items_discipline.collection;
    }
};
var competitions_updateCompetitionSelectorItemsFunction = function (compId, draft) {
    var cs = getCompetitionSubStore(draft, compId);
    competitions_updateCompSeriesItems(compId, draft);
    competitions_updateCompCompetitorItems(compId, draft);
    competitions_updateCompTypeItems(compId, draft);
    competitions_updateCompAgeItems(compId, draft);
    competitions_updateCompClassItems(compId, draft);
    competitions_updateCompDisciplineItems(compId, draft);
    cs.showToClassField = cs.entity.typeId === CompetitionType.Cup && (cs.entity.seriesId === SeriesType.DanceSport || (cs.entity.seriesId === SeriesType.DanceForAll && cs.entity.competitorId !== CompetitorType.Couple));
    if (cs.entity.typeId !== CompetitionType.Cup) {
        cs.entity.toClassId = undefined;
    }
    else if (!cs.showToClassField) {
        cs.entity.toClassId = cs.entity.fromClassId;
    }
    cs.showFromClassField = true;
    // copied from the code above
    if (cs.entity.seriesId == SeriesType.DanceForAll) {
        if (cs.entity.typeId == CompetitionType.Cup) {
            // condition for having ranking form of competitions OR SingleDance Cup
            if ([CompetitorType.SoloDancer, CompetitorType.Duo].includes(cs.entity.competitorId) && [DisciplineType.Standard, DisciplineType.Latin, DisciplineType.Standard_Latin, DisciplineType.SingleDance].includes(cs.entity.disciplineId)) {
            }
            else if (cs.entity.competitorId && cs.entity.disciplineId) {
                // ranking form doesn't exist
                cs.showFromClassField = false;
                cs.entity.fromClassId = undefined;
                cs.showToClassField = false;
                cs.entity.toClassId = undefined;
            }
        }
    }
    if (cs.entity.typeId === CompetitionType.Cup && cs.entity.fromClassId === CompetitionClassType.Open) {
        cs.showToClassField = false;
        cs.entity.toClassId = undefined;
    }
};
var competitions_updateCompetitionSelectorItemsForAll = function (draft) {
    draft.s_competitions.competitions.collection.forEach(function (c) {
        competitions_updateCompetitionSelectorItemsFunction(c.entity.id, draft);
    });
    competitions_updateCompetitionSelectorItemsFunction(null, draft);
};
var competitions_startDancesEditing = function (compId) { return function (store) {
    store.setState(function (draft) {
        getCompetitionSubStore(draft, compId).showDancesDialog = true;
    });
}; };
var competitions_stopDancesEditing = function (compId, dances) {
    if (dances === void 0) { dances = null; }
    return function (store) {
        var save = dances != null;
        store.setState(function (draft) {
            getCompetitionSubStore(draft, compId).showDancesDialog = false;
            if (save) {
                getCompetitionSubStore(draft, compId).entity.dances = dances;
            }
        });
        if (save && compId !== null) {
            store.dispatch(competitions_saveCompetition(compId, true));
        }
    };
};
var competitions_setCompetitionErrors = function (draft, compId, errors) {
    getCompetitionSubStore(draft, compId).errors = errors;
};
var CompetitionsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), competitionErrors: {}, order: "type" });
var TempCompetitionsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompetitionsFunction = function (eventId, order, store, reset_filter) {
    if (reset_filter === void 0) { reset_filter = false; }
    var loader = function () { return apiGetCompetitions(eventId, null, order); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            if (response.succeeded) {
                var temp_collection_state = __assign({}, TempCompetitionsStateDefaults);
                updateByCollectionResponse(temp_collection_state, response);
                draft.s_competitions.competitions.collection = [];
                temp_collection_state.collection.forEach(function (c) {
                    var new_comp_store = __assign({}, CompetitionStateDefaults);
                    new_comp_store.entity = c;
                    new_comp_store.lastSavedEntity = c;
                    draft.s_competitions.competitions.collection.push(new_comp_store);
                });
                draft.s_competitions.competitions.errors = JSON.parse(JSON.stringify(temp_collection_state.errors));
                if (reset_filter) {
                    competitions_resetFilterFunction(draft);
                }
                competitions_filterCompetitionsFunction(draft);
                competitions_checkInitialization(draft);
            }
        });
        var state = store.getState().s_competitions;
        state.competitions.collection.forEach(function (c) {
            competitions_loadCompDefaultDancesFunction(c.entity.id, store);
        });
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.competitions; });
};
var competitions_deleteCompetition = function (competition) { return function (store) {
    store.setState(function (draft) {
        getCompetitionSubStore(draft, competition.id).deletionFailed = false;
    });
    var updater = function () { return apiDeleteCompetition(competition.eventId, competition.id); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var item = draft.s_competitions.competitions.collection.find(function (x) { return x.entity.id == competition.id; });
                var index = draft.s_competitions.competitions.collection.indexOf(item);
                if (index > -1) {
                    draft.s_competitions.competitions.collection.splice(index, 1);
                }
            });
        }
        else {
            store.setState(function (draft) {
                getCompetitionSubStore(draft, competition.id).deletionFailed = true;
            });
        }
    };
    update(store, updater, stateProducer, function (s) { return s.s_competitions.competitions; });
}; };
var competitions_openDeleteCompetitionConfirmationDialog = function (compId) { return function (store) {
    store.setState(function (draft) {
        getCompetitionSubStore(draft, compId).showDeleteConfirmationDialog = true;
        getCompetitionSubStore(draft, compId).deletionFailed = false;
    });
}; };
var competitions_closeDeleteCompetitionConfirmationDialog = function (compId) { return function (store) {
    store.setState(function (draft) {
        getCompetitionSubStore(draft, compId).showDeleteConfirmationDialog = false;
    });
}; };
var competitions_cloneCompetition = function (competition) { return function (store) {
    var index = null;
    store.getState().s_competitions.competitions.collection.forEach(function (c, i) { if (c.entity.id == competition.id) {
        index = i;
    } });
    var new_competition = JSON.parse(JSON.stringify(competition));
    new_competition.id = 0;
    if (index === null) {
        index = store.getState().s_competitions.competitions.collection.length;
    }
    store.setState(function (draft) {
        draft.s_competitions.new_competition.entity = new_competition;
    });
    if (!competitions_validate(store, null, false)) {
        return;
    }
    var updater = function () { return apiCreateCompetition(new_competition.eventId, new_competition); };
    var stateProducer = function (store, _, response) {
        var new_comp_id = null;
        store.setState(function (draft) {
            updateByEntityResponse(draft.s_competitions.new_competition, response);
            if (response.succeeded) {
                new_comp_id = draft.s_competitions.new_competition.entity.id;
                draft.s_competitions.new_competition.lastSavedEntity = draft.s_competitions.new_competition.entity;
                var new_comp_store = __assign({}, CompetitionStateDefaults);
                new_comp_store.entity = draft.s_competitions.new_competition.entity;
                new_comp_store.lastSavedEntity = draft.s_competitions.new_competition.entity;
                if (index === null) {
                    draft.s_competitions.competitions.collection.push(new_comp_store);
                }
                else {
                    draft.s_competitions.competitions.collection.splice(index, 0, new_comp_store);
                }
                competitions_updateCompetitionSelectorItemsFunction(new_comp_store.entity.id, draft);
                competitions_filterCompetitionsFunction(draft);
            }
        });
        if (new_comp_id) {
            competitions_loadCompDefaultDancesFunction(new_comp_id, store);
        }
    };
    update(store, updater, stateProducer, function (s) { return s.s_competitions.competitions; });
}; };
var competitions_createNewCompetition = function (eventId, predefinedEntity) {
    if (predefinedEntity === void 0) { predefinedEntity = null; }
    return function (store) {
        store.setState(function (draft) {
            if (predefinedEntity) {
                draft.s_competitions.new_competition.entity = __assign(__assign({}, predefinedEntity), { id: 0, eventId: eventId, dayOfEvent: 1 });
            }
            else {
                draft.s_competitions.new_competition.entity = {
                    id: 0,
                    eventId: eventId,
                    dayOfEvent: 1,
                    dances: [],
                };
            }
            draft.s_competitions.new_competition.errors = __assign({}, CompetitionStateDefaults.errors);
            draft.s_competitions.new_competition.lastSavedEntity = draft.s_competitions.new_competition.entity;
            draft.s_competitions.new_competition.newCompetitionPhase = NewCompetitionPhase.None;
            draft.s_competitions.new_competition.showNewCompetitionDialog = true;
            competitions_updateCompetitionSelectorItemsFunction(null, draft);
        });
        competitions_loadCompDefaultDancesFunction(null, store);
    };
};
var competitions_cancelNewCompetition = function () { return function (store) {
    store.setState(function (draft) {
        draft.s_competitions.new_competition.showNewCompetitionDialog = false;
    });
}; };
var competitions_updateCompetitionErrors = function (errors) { return function (store) {
    var competitionErrors = {};
    Object.entries(errors).forEach(function (x) {
        var _a;
        if (x[0].startsWith('[')) {
            var segments = x[0].replace('[', '').split(']');
            if (segments[1].startsWith('.')) {
                segments[1] = segments[1].substring(1);
            }
            competitionErrors[segments[0]] = __assign(__assign({}, competitionErrors[segments[0]]), (_a = {}, _a[segments[1]] = x[1], _a));
        }
    });
    store.setState(function (draft) {
        draft.s_competitions.competitions.competitionErrors = competitionErrors;
        draft.s_competitions.competitions.collection.forEach(function (c) {
            if (competitionErrors[c.entity.id]) {
                competitions_setCompetitionErrors(draft, c.entity.id, competitionErrors[c.entity.id]);
            }
        });
    });
}; };
var competitions_setOrder = function (order) { return function (store) {
    store.setState(function (draft) {
        draft.s_competitions.competitions.order = order;
    });
    competitions_loadCompetitionsFunction(store.getState().s_competitions.eventId, order, store);
}; };
var competitions_setEventId = function (eventId) { return function (store) {
    store.setState(function (draft) {
        draft.s_competitions.eventId = eventId;
        draft.s_competitions.competitions.collection = [];
        draft.s_competitions.competitions.order = "type";
    });
    var state = store.getState().s_competitions;
    if (!state.items_age.collection.length) {
        competitions_loadCompAges(store);
    }
    if (!state.items_class.collection.length) {
        competitions_loadCompClasses(store);
    }
    if (!state.items_competitor.collection.length) {
        competitions_loadCompCompetitors(store);
    }
    if (!state.items_discipline.collection.length) {
        competitions_loadCompDisciplines(store);
    }
    if (!state.items_series.collection.length) {
        competitions_loadCompSeries(store);
    }
    if (!state.items_type.collection.length) {
        competitions_loadCompTypes(store);
    }
    var reset_filter = true;
    competitions_loadCompetitionsFunction(eventId, store.getState().s_competitions.competitions.order, store, reset_filter);
}; };
var CompCompetitorStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompCompetitors = function (store) {
    var loader = function () { return apiGetCompCompetitors(); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_competitions.items_competitor, response);
                draft.s_competitions.items_competitor.collection.sort(function (a, b) { return a.order - b.order; });
                competitions_checkInitialization(draft);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.items_competitor; });
};
var CompClassStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompClasses = function (store) {
    var loader = function () { return apiGetCompClasses(); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_competitions.items_class, response);
                draft.s_competitions.items_class.collection.sort(function (a, b) { return a.order - b.order; });
                competitions_checkInitialization(draft);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.items_class; });
};
var CompAgeStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompAges = function (store) {
    var loader = function () { return apiGetCompAges(); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_competitions.items_age, response);
                draft.s_competitions.items_age.collection.sort(function (a, b) { return a.order - b.order; });
                competitions_checkInitialization(draft);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.items_age; });
};
var CompDisciplineStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompDisciplines = function (store) {
    var loader = function () { return apiGetCompDisciplines(); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_competitions.items_discipline, response);
                draft.s_competitions.items_discipline.collection.sort(function (a, b) { return a.order - b.order; });
                competitions_checkInitialization(draft);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.items_discipline; });
};
var CompSeriesStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompSeries = function (store) {
    var loader = function () { return apiGetCompSeries(); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_competitions.items_series, response);
                draft.s_competitions.items_series.collection.sort(function (a, b) { return a.order - b.order; });
                competitions_checkInitialization(draft);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.items_series; });
};
var CompTypeStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var competitions_loadCompTypes = function (store) {
    var loader = function () { return apiGetCompTypes(); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_competitions.items_type, response);
                draft.s_competitions.items_type.collection.sort(function (a, b) { return a.order - b.order; });
                competitions_checkInitialization(draft);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.s_competitions.items_type; });
};
// All
var competitions_checkInitialization = function (draft) {
    if (draft.s_competitions.items_age.collection.length
        && draft.s_competitions.items_class.collection.length
        && draft.s_competitions.items_competitor.collection.length
        && draft.s_competitions.items_discipline.collection.length
        && draft.s_competitions.items_series.collection.length
        && draft.s_competitions.items_type.collection.length) {
        draft.s_competitions.items_loaded = true;
        competitions_updateCompetitionSelectorItemsForAll(draft);
    }
};
var Competitions_StateDefaults = __assign(__assign({}, LoadingStateDefaults), { eventId: null, filter: __assign({}, FilterStateDefaults), new_competition: __assign({}, NewCompetitionStateDefaults), competitions: __assign({}, CompetitionsStateDefaults), items_competitor: __assign({}, CompCompetitorStateDefaults), items_class: __assign({}, CompClassStateDefaults), items_age: __assign({}, CompAgeStateDefaults), items_discipline: __assign({}, CompDisciplineStateDefaults), items_series: __assign({}, CompSeriesStateDefaults), items_type: __assign({}, CompTypeStateDefaults), items_loaded: false });
var ConcurrentEventsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { errors: __assign({}, NoEntityError), collection: [] });
var technicalInfo_loadConcurrentEvents = function () { return function (store) {
    var _a, _b;
    var state = store.getState();
    var eventDateFrom = (_a = state.s_event.entity) === null || _a === void 0 ? void 0 : _a.dateFrom;
    var eventDateTo = (_b = state.s_event.entity) === null || _b === void 0 ? void 0 : _b.dateTo;
    if (eventDateFrom && eventDateTo) {
        var fields = [
            "state IN(".concat(EventState.Public, ")"),
            "date>=" + getIsoStringDate(eventDateFrom).substring(0, 10),
            "date<=" + getIsoStringDate(eventDateTo).substring(0, 10),
        ];
        var filter_1 = fields.join(" AND ");
        var loader = function () { return apiGetEvents(filter_1); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.s_technicalInfo.concurrentEvents, response);
            });
        };
        loadLast(store, loader, stateProducer, function (s) { return s.s_technicalInfo.concurrentEvents; });
    }
}; };
var technicalInfo_setAllowedRegistrationForConcurrentEvent = function (eventId, value) { return function (store) {
    var _a, _b;
    var state = store.getState();
    var concurrentEvents = ((_b = (_a = state.s_event.entity) === null || _a === void 0 ? void 0 : _a.canAlsoRegister) === null || _b === void 0 ? void 0 : _b.split(";").map(function (x) { return parseInt(x); })) || [];
    if (concurrentEvents.includes(eventId)) {
        concurrentEvents.splice(concurrentEvents.indexOf(eventId), 1);
    }
    else {
        concurrentEvents.push(eventId);
    }
    store.setState(function (draft) {
        draft.s_event.entity.canAlsoRegister = concurrentEvents.join(";");
    });
    store.dispatch(event_saveEvent(false));
}; };
var technicalInfo_setPrivateInCalendar = function (value) { return function (store) {
    store.setState(function (draft) {
        draft.s_event.entity.eventCompetitions[0].privateInCalendar = value;
    });
    store.dispatch(event_saveEvent(false));
}; };
var TechnicalInfoStateDefaults = {
    concurrentEvents: __assign({}, ConcurrentEventsStateDefaults),
};
var StateDefaults = {
    s_tabs: Tabs_StateDefaults,
    s_event: Event_StateDefaults,
    s_officials: Officials_StateDefaults,
    s_competitions: Competitions_StateDefaults,
    s_technicalInfo: TechnicalInfoStateDefaults,
};
var store = createStore({
    initialState: StateDefaults,
    actions: {
        // --------------------------------------------------
        // Tabs actions
        tabs_setPage: tabs_setPage,
        // --------------------------------------------------
        // Event actions
        event_resetCreationState: event_resetCreationState,
        event_createEvent: event_createEvent,
        event_loadEvent: event_loadEvent,
        event_saveEvent: event_saveEvent,
        event_setEntityField: event_setEntityField,
        event_cancelCheck: event_cancelCheck,
        event_showCancelDialog: event_showCancelDialog,
        event_hideCancelDialog: event_hideCancelDialog,
        // --------------------------------------------------
        // Officials actions
        officials_loadEventCompOfficials: officials_loadEventCompOfficials,
        officials_openNewOfficialDialog: officials_openNewOfficialDialog,
        officials_openRegisterForeignAdjudicatorDialog: officials_openRegisterForeignAdjudicatorDialog,
        officials_addNewOfficial: officials_addNewOfficial,
        officials_deleteOfficial: officials_deleteOfficial,
        officials_closeDialog: officials_closeDialog,
        officials_filterOfficials: officials_filterOfficials,
        officials_selectOfficial: officials_selectOfficial,
        officials_addSelectedOfficial: officials_addSelectedOfficial,
        officials_loadAllOfficials: officials_loadAllOfficials,
        officials_setEventId: officials_setEventId,
        officials_setRegisterForeignAdjudicatorEntityField: officials_setRegisterForeignAdjudicatorEntityField,
        officials_registerAndAddNewForeignAdjudicator: officials_registerAndAddNewForeignAdjudicator,
        officials_setNewOfficialRole: officials_setNewOfficialRole,
        officials_getAvailableOfficialRoles: officials_getAvailableOfficialRoles,
        officials_setRoleOfOfficial: officials_setRoleOfOfficial,
        // --------------------------------------------------
        // Competitions actions
        // filter
        competitions_resetFilter: competitions_resetFilter,
        competitions_setFilterEntityField: competitions_setFilterEntityField,
        // competition
        competitions_saveCompetition: competitions_saveCompetition,
        competitions_startDancesEditing: competitions_startDancesEditing,
        competitions_stopDancesEditing: competitions_stopDancesEditing,
        competitions_setCompetitionEntityField: competitions_setCompetitionEntityField,
        competitions_setCompetitionEntityFieldWithSave: competitions_setCompetitionEntityFieldWithSave,
        // competitions
        competitions_deleteCompetition: competitions_deleteCompetition,
        competitions_cloneCompetition: competitions_cloneCompetition,
        competitions_createNewCompetition: competitions_createNewCompetition,
        competitions_cancelNewCompetition: competitions_cancelNewCompetition,
        competitions_updateCompetitionErrors: competitions_updateCompetitionErrors,
        competitions_setOrder: competitions_setOrder,
        competitions_openDeleteCompetitionConfirmationDialog: competitions_openDeleteCompetitionConfirmationDialog,
        competitions_closeDeleteCompetitionConfirmationDialog: competitions_closeDeleteCompetitionConfirmationDialog,
        competitions_setLastActionValidationToAllCompetitions: competitions_setLastActionValidationToAllCompetitions,
        // --------------------------------------------------
        // Technical info actions
        // concurrent events
        technicalInfo_loadConcurrentEvents: technicalInfo_loadConcurrentEvents,
        technicalInfo_setAllowedRegistrationForConcurrentEvent: technicalInfo_setAllowedRegistrationForConcurrentEvent,
        technicalInfo_setPrivateInCalendar: technicalInfo_setPrivateInCalendar,
        // all
        competitions_setEventId: competitions_setEventId,
    },
    name: "EventPlanningEdit"
});
// --------------------------------------------------
// Tabs substore
var getTabsSubState = createSelector(function (state) { return state.s_tabs; }, function (__, props) { return null; }, function (tabs, __) { return tabs; });
var useTabsSubState = createHook(store, {
    selector: getTabsSubState,
});
// --------------------------------------------------
// Event substore
var getEventSubState = createSelector(function (state) { return state.s_event; }, function (__, props) { return null; }, function (event, __) { return event; });
var useEventSubState = createHook(store, {
    selector: getEventSubState,
});
// --------------------------------------------------
// Officials substores
// officials substore
var getOfficialsBaseState = createSelector(function (state) { return state.s_officials; }, function (__, props) { return null; }, function (substate, __) { return substate; });
var useEventPlanning_Officials = createHook(store, {
    selector: getOfficialsBaseState,
});
// officials counts
var getOfficialsCounts = createSelector(function (state) {
    var counts = {};
    ["Standard", "Latin"].forEach(function (discipline) { return getAdjudicatorLicenceKeys().forEach(function (licKey) {
        counts[discipline + licKey] = 0;
    }); });
    state.s_officials.officials.collection.filter(function (o) { return o.role == OfficialRole.Adjudicator; }).forEach(function (o) {
        var official = getOfficialByIdt(o.idt, state);
        if (official !== undefined) {
            ["Standard", "Latin"].forEach(function (discipline) {
                var grade = getOfficialLicenseKey(official, OfficialRole.Adjudicator, discipline);
                if (grade) {
                    counts[discipline + grade] += 1;
                }
            });
        }
    });
    return counts;
}, function (__, props) { return null; }, function (counts, __) {
    var res_stt = getAdjudicatorLicenceKeys(true).map(function (licKey) {
        return counts["Standard" + licKey].toString() + "×" + getAdjudicatorLicenceNaming(licKey);
    }).join(", ");
    var res_lat = getAdjudicatorLicenceKeys(true).map(function (licKey) {
        return counts["Latin" + licKey].toString() + "×" + getAdjudicatorLicenceNaming(licKey);
    }).join(", ");
    return {
        stt: res_stt,
        lat: res_lat,
    };
});
var useEventPlanning_Officials_Counts = createHook(store, {
    selector: getOfficialsCounts,
});
// officials list substore
var getOfficialsState = createSelector(function (state) { return state.s_officials.officials; }, function (__, props) { return null; }, function (substate, __) { return substate; });
var useEventPlanning_Officials_List = createHook(store, {
    selector: getOfficialsState,
});
// all officials list substore
var getAllOfficialsState = createSelector(function (state) { return state.s_officials.allOfficials; }, function (__, props) { return null; }, function (substate, __) { return substate; });
var useEventPlanning_Officials_AllOfficialsList = createHook(store, {
    selector: getAllOfficialsState,
});
// new official substore
var getNewOfficialState = createSelector(function (state) { return state.s_officials.newOfficial; }, function (__, props) { return null; }, function (substate, __) { return substate; });
var useEventPlanning_Officials_NewOfficial = createHook(store, {
    selector: getNewOfficialState,
});
// register foreign adjudicator substore
var getRegisterForeignAdjudicatorState = createSelector(function (state) { return state.s_officials.registerForeignAdjudicator; }, function (__, props) { return null; }, function (substate, __) { return substate; });
var useEventPlanning_Officials_RegisterForeignAdjudicator = createHook(store, {
    selector: getRegisterForeignAdjudicatorState,
});
var getCompetitionSubState = createSelector(function (__) { return null; }, function (state, props) { return props.compId === null ? state.s_competitions.new_competition : state.s_competitions.competitions.collection.find(function (c) { return c.entity.id === props.compId; }); }, function (__, comp_store) { return comp_store; });
var useEventPlanning_Competitions_CompetitionSubState = createHook(store, {
    selector: getCompetitionSubState,
});
// is competition filtered ?
var getCompetitionIsFiltered = createSelector(function (__) { return null; }, function (state, props) { return state.s_competitions.filter.filtered_competition_ids.includes(props.compId); }, function (__, showCompetition) { return showCompetition; });
var useEventPlanning_Competitions_CompetitionIsFiltered = createHook(store, {
    selector: getCompetitionIsFiltered,
});
// new_competition substore
var getNewCompetitionSubState = createSelector(function (state) { return state.s_competitions.new_competition; }, function (__, props) { return null; }, function (new_competition, __) { return new_competition; });
var useEventPlanning_Competitions_NewCompetitionSubState = createHook(store, {
    selector: getNewCompetitionSubState,
});
// all competition ids
var getCompetitionIDsArrayState = createSelector(function (__) { return null; }, function (state, props) { return state.s_competitions.competitions.collection.map(function (c) { return c.entity.id; }); }, function (__, collection) { return collection; });
var useEventPlanning_Competitions_CompetitionIDsArrayState = createHook(store, {
    selector: getCompetitionIDsArrayState,
});
// filter substore
var getCompetitionFilterState = createSelector(function (state) { return state.s_competitions.filter; }, function (__, props) { return null; }, function (filter, __) { return filter; });
var useEventPlanning_Competitions_FilterState = createHook(store, {
    selector: getCompetitionFilterState,
});
// selector items substore
var getCompetitionSelectorItemsState = createSelector(function (state) {
    return {
        items_age: state.s_competitions.items_age,
        items_class: state.s_competitions.items_class,
        items_competitor: state.s_competitions.items_competitor,
        items_discipline: state.s_competitions.items_discipline,
        items_series: state.s_competitions.items_series,
        items_type: state.s_competitions.items_type
    };
}, function (__, props) { return null; }, function (items_states, __) { return items_states; });
var useEventPlanning_Competitions_SelectorItemsState = createHook(store, {
    selector: getCompetitionSelectorItemsState,
});
// loading state
var getCompetitionsLoadingState = createSelector(function (state) {
    return {
        items_loaded: state.s_competitions.items_loaded,
        any_loading: false //state.s_competitions.competitions.loading
            || state.s_competitions.items_age.loading
            || state.s_competitions.items_class.loading
            || state.s_competitions.items_competitor.loading
            || state.s_competitions.items_discipline.loading
            || state.s_competitions.items_series.loading
            || state.s_competitions.items_type.loading,
        any_loadFailure: state.s_competitions.competitions.loadFailure
            || state.s_competitions.items_age.loadFailure
            || state.s_competitions.items_class.loadFailure
            || state.s_competitions.items_competitor.loadFailure
            || state.s_competitions.items_discipline.loadFailure
            || state.s_competitions.items_series.loadFailure
            || state.s_competitions.items_type.loadFailure,
        any_loadingTooLong: state.s_competitions.competitions.loadingTooLong
            || state.s_competitions.items_age.loadingTooLong
            || state.s_competitions.items_class.loadingTooLong
            || state.s_competitions.items_competitor.loadingTooLong
            || state.s_competitions.items_discipline.loadingTooLong
            || state.s_competitions.items_series.loadingTooLong
            || state.s_competitions.items_type.loadingTooLong,
    };
}, function (__, props) { return null; }, function (loading_state, __) { return loading_state; });
var useEventPlanning_Competitions_LoadingState = createHook(store, {
    selector: getCompetitionsLoadingState,
});
// --------------------------------------------------
// Technical info substore
var getTechnicalInfoSubState = createSelector(function (state) { return state.s_technicalInfo; }, function (__, props) { return null; }, function (event, __) { return event; });
var useEventPlanning_TechnicalInfo = createHook(store, {
    selector: getTechnicalInfoSubState,
});
// --------------------------------------------------
// Only actions
var useActions = createActionsHook(store);
// --------------------------------------------------
// Whole store
// const useState = createHook(store);
export { 
// useState as useEventPlanning,// not used
// Tabs
useTabsSubState as useEventPlanning_Tabs, 
// Event
useEventSubState as useEventPlanning_Event, useEventPlanning_Officials, useEventPlanning_Officials_List, useEventPlanning_Officials_NewOfficial, useEventPlanning_Officials_AllOfficialsList, useEventPlanning_Officials_RegisterForeignAdjudicator, useEventPlanning_Officials_Counts, useEventPlanning_Competitions_CompetitionSubState, useEventPlanning_Competitions_NewCompetitionSubState, useEventPlanning_Competitions_CompetitionIDsArrayState, useEventPlanning_Competitions_FilterState, useEventPlanning_Competitions_LoadingState, useEventPlanning_Competitions_SelectorItemsState, useEventPlanning_Competitions_CompetitionIsFiltered, 
// Technical info
useEventPlanning_TechnicalInfo, 
//Actions
useActions as useEventPlanning_Actions, };
